// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"styles-module__searchWrapper___2YiYC","search":"styles-module__search___3SL76"};